export function getVersion() {
  const element = document.getElementById("app-build-version");

  return element?.getAttribute("build-version");
}
